import React, {
  useEffect,
  useState,
  useImperativeHandle,
  forwardRef,
} from "react";
import { EditOutlined } from "@ant-design/icons";

import { Table, Button } from "antd";

import { all as AllSurgicalProcedure } from "../../api/SurgicalProcedure";

import { types } from '../../constants';

const SurgicalProcedureTable = forwardRef((props, ref) => {

  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10,
    showSizeChanger: true,
    position: ["topRight"],
  });

  const [sorter, setSorter] = useState({});

  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);

  const columns = [
    {
      title: "Procédure",
      dataIndex: "name",
      sorter: true,
    },
    {
      title: "Type de chirurgie",
      dataIndex: "type",
      sorter: true,
      render: (obj) => {
        let type = types.find((elem) => elem.id === obj);
        if (!type) return "inconnu";
        return type.label;
      },
    },
    {
      title: "Nuits",
      dataIndex: "duration_of_stay",
      sorter: true,
    },
    {
      title: "SB",
      dataIndex: "siips",
      render: (obj) => obj.base,
      sorter: true,
    },
    {
      title: "ST",
      dataIndex: "siips",
      render: (obj) => obj.technical,
      sorter: true,
    },
    {
      title: "SR",
      dataIndex: "siips",
      render: (obj) => obj.relational,
      sorter: true,
    },
    {
      render: (data) => {
        return (
          <Button
            type="primary"
            shape="circle"
            icon={<EditOutlined />}
            size="large"
            onClick={() => props.onEdit(data.id)}
          ></Button>
        );
      },
      width: 30,
    },
  ];

  let getParams = (pagination, sorter) => {
    let params = {
      current: pagination.current,
      pageSize: pagination.pageSize,
    };

    if (sorter !== undefined && sorter.column !== undefined) {
      let { field, order } = sorter;
      order = (order === "ascend") ? 1 : -1;

      if (!!field && !!order) {
        params['sort'] = field + "," + order;
      }
    }

    return params;
  };

  let fetch = async function (pagination, filters, sorter) {
    setLoading(true);
    setSorter(sorter);

    let params = getParams(pagination, sorter);

    AllSurgicalProcedure(params)
      .then((data) => {
        setData(data.results);
        setPagination({
          ...pagination,
          total: data.total,
        });
        setLoading(false);
      });
  };

  let reload = async function () {
    return fetch(pagination, null, sorter);
  };

  useEffect(() => {
    fetch({ ...pagination });
  }, []);

  useImperativeHandle(ref, () => ({
    fetch: () => {
      fetch({ ...pagination });
    },
    reload: reload
  }));

  return (
    <Table
      columns={columns}
      rowKey={(record) => record.id}
      dataSource={data}
      pagination={pagination}
      loading={loading}
      onChange={fetch}
    />
  );
});

export default SurgicalProcedureTable;